import * as yup from 'yup';

/** Standard schema to validate Russina checking account numbers */
export const russianCheckingAccountSchema = yup
  .string()
  .matches(/^\d{20}$/i, 'Номер расчетного счета должен состоять из 20 цифр');
